import React from 'react';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import { ThemeProvider } from 'styled-components';
import { ModalProvider } from 'styled-react-modal';
import { ThemeProvider as MUIThemeProvider } from '@mui/material';
import { AppRoutes } from './Routes';
import type { AppHistory } from '../store';
import type { Store } from 'redux';
import { Provider } from 'react-redux';
import muiTheme from './style/theme';
import theme from '../design/theme';
import { Config } from '../config';
import { ConfigProvider } from './config';

export const App: React.FC<{ config: Config; store: Store; history: AppHistory }> = ({ config, history, store }) => (
    <ConfigProvider config={config}>
        <Provider store={store}>
            <MUIThemeProvider theme={muiTheme}>
                <ThemeProvider theme={theme}>
                    <Router history={history}>
                        <React.StrictMode>
                            <ModalProvider>
                                <AppRoutes />
                            </ModalProvider>
                        </React.StrictMode>
                    </Router>
                </ThemeProvider>
            </MUIThemeProvider>
        </Provider>
    </ConfigProvider>
);
